import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import '../App.css';

function CustomNavbar({ activeSection, setActiveSection }) {
  const handleNavClick = (section) => {
    setActiveSection(section);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 🔥 Scroll suave para o topo
  };

  return (
    <Navbar expand="lg" className="site-header sticky-top">
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link
            href="#"
            className={activeSection === 'Home' ? 'ativo' : ''}
            onClick={() => handleNavClick('Home')}
          >
            Home
          </Nav.Link>
          <Nav.Link
            href="#"
            className={activeSection === 'Cursos' ? 'ativo' : ''}
            onClick={() => handleNavClick('Cursos')}
          >
            Cursos
          </Nav.Link>
          <Nav.Link
            href="#"
            className={activeSection === 'Projetos' ? 'ativo' : ''}
            onClick={() => handleNavClick('Projetos')}
          >
            Projetos
          </Nav.Link>
          
          <Nav.Link
            href="#"
            className={activeSection === 'Atendimento' ? 'ativo' : ''}
            onClick={() => handleNavClick('Atendimento')}
          >
            Atendimento
          </Nav.Link>
          <Nav.Link
            href="#"
            className={activeSection === 'SupervisaoEscolar' ? 'ativo' : ''}
            onClick={() => handleNavClick('SupervisaoEscolar')}
          >
            Supervisão Escolar
          </Nav.Link>
          <Nav.Link
            href="#"
            className={activeSection === 'Grupos' ? 'ativo' : ''}
            onClick={() => handleNavClick('Grupos')}
          >
            Grupos de Estudos
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default CustomNavbar;
